import React, { useContext, useEffect, useRef, useState } from 'react';
import './SearchUsers.scss';
import Spinner from './Spinner';
import { UsersClient } from '../../services/http/apis/usersClient';
import { debounce, getUserDisplayName } from '../../services/utils';
import { captureException, setExtra } from '@sentry/react';
import { sendActionLogs } from '../../services/logs';
import { DeviceAuthContext } from '@inspace-org/react-auth';

const SearchHosts = ({ value = '', onBlur, onChange, setValueHost, helperText, error, placeholder, hostsList }) => {
  const { settings, device, companySettings } = useContext(DeviceAuthContext);
  const [stateHostsList, setStateHostsList] = useState(hostsList || []);
  const [isLoadingHost, setLoadingHost] = useState(false);
  const hostsListWrapRef = useRef(null);
  const usersClient = new UsersClient();

  useEffect(() => {
    if (hostsListWrapRef.current && hostsList.length > 2) {
      hostsListWrapRef.current.classList.add('form_shadow');
      hostsListWrapRef.current.addEventListener('scroll', (e) => {
        if (
          hostsListWrapRef.current.scrollHeight - hostsListWrapRef.current.scrollTop ===
          hostsListWrapRef.current.clientHeight
        ) {
          hostsListWrapRef.current.classList.remove('form_shadow');
        } else {
          hostsListWrapRef.current.classList.add('form_shadow');
        }
      });
    }
  }, [hostsListWrapRef, stateHostsList]);

  const loadUsers = async (value) => {
    if (value !== '') {
      try {
        setLoadingHost(true);
        const { items } = await usersClient.getHosts({ search: value });
        setStateHostsList(items);
      } catch (err) {
        setStateHostsList([]);
        setExtra('Error Data', {
          status: err?.status,
          url: err?.url,
          body: err?.data,
          payload: value,
        });
        captureException(err);
        console.error(err);
        sendActionLogs({
          errors: err,
          device,
          companySettings,
          settings,
          actionName: 'load Hosts',
          actionPath: 'Search Host component',
        });
      } finally {
        setLoadingHost(false);
      }
    } else {
      setStateHostsList([]);
    }
  };

  const handelChangeInput = (e) => {
    const val = e.target.value;
    getDebouncedUsers(val);
    setValueHost(val);
    onChange('');
  };

  const getDebouncedUsers = debounce(loadUsers, 100);

  const handleSelectUser = (host) => {
    setValueHost(getUserDisplayName(host));
    onChange(host.id || host._id);
  };

  return (
    <div className="form_field">
      <input
        className={`form_input ${error ? 'error' : ''}`}
        name="hosts"
        placeholder={placeholder}
        value={value}
        onChange={handelChangeInput}
        onBlur={onBlur}
      />
      {error && <div className="error_text">{helperText}</div>}
      {isLoadingHost ? (
        <Spinner />
      ) : (
        <div className="form_users" ref={hostsListWrapRef}>
          {stateHostsList.map((user) => (
            <div key={user.id || user.id} className="user" onClick={() => handleSelectUser(user)}>
              <div className="user_avatar">
                <div className="avatar">{getUserDisplayName(user, 'avatar').toUpperCase()}</div>
              </div>
              <div className="user_name">{getUserDisplayName(user)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchHosts;
